app.controller('popupReferralController', ['$scope', '$state', '$q', '$mdDialog', '$timeout', '$translate', '$injector', 'objectHelper',
    'baseModel', 'applicationModel', 'visitModel', 'userModel', 'dictionaryModel', 'doctorModel', 'referralModel', 'referral',
    'visitCard', 'patient', 'diagnosis', 'referralType', 'previewOnly', 'meedyALABModel', 'nfzContracts', 'nfzOfficeModel',
    function ($scope, $state, $q, $mdDialog, $timeout, $translate, $injector, objectHelper, baseModel, applicationModel, visitModel,
              userModel, dictionaryModel, doctorModel, referralModel, referral, visitCard, patient, diagnosis, referralType,
              previewOnly, meedyALABModel, nfzContracts, nfzOfficeModel) {

        function loadSelectedTests(testArray, selectedTestsArray) {
            var mapped = testArray.map(function(el) { return el.id; });

            selectedTestsArray.forEach(function(selectedElement) {
                var indexOfParentElement = mapped.indexOf(selectedElement.parent.id);

                testArray[indexOfParentElement].children.forEach(function(el, index, currentArray) {
                    if(el.id === selectedElement.id) {
                        el.checked = true;
                    }
                });
            });
        }

        function prepareIds() {
            if($scope.referral.type === Enum.REFERRAL_TYPE.ALAB) {
                $scope.referral.name = $scope.referral.alabResource.name;
                $scope.referral.alabResource.externalSystemIdentifier = $scope.referral.alabResource.id;
                $scope.referral.alabResource = new ALABResourceVO($scope.referral.alabResource.id, $scope.referral.alabResource.name, $scope.referral.alabResource.id);
            }

            // Set empty strings when hospital name and address not provided (fields no longer obligatory)
            if($scope.referral.type === Enum.REFERRAL_TYPE.HOSPITAL) {
                if (!$scope.referral.name) {
                    $scope.referral.name = "";
                }
                if (!$scope.referral.unitName) {
                    $scope.referral.unitName = "";
                }
                if (!$scope.referral.address) {
                    $scope.referral.address = "";
                }
            }

            if ($scope.eReferralICD9 || $scope.eReferralDescription || $scope.eReferralICD9Second) {
                var fisrtDot = '';
                $scope.referral.description = $scope.eReferralDescription ? $scope.eReferralDescription : '';

                if ($scope.eReferralDescription && ($scope.eReferralDescription || $scope.eReferralICD9Second)) {
                    if ($scope.eReferralDescription.charAt($scope.eReferralDescription.length-1) === '.') {
                        fisrtDot = ' ';
                    } else {
                        fisrtDot = '. ';
                    }
                }
                $scope.referral.description += fisrtDot;
                $scope.referral.description += $scope.eReferralICD9 ? 'Procedura ICD-9: ' + $scope.eReferralICD9.value + ' - ' + $scope.eReferralICD9.description + '. ' : '';
                $scope.referral.description += $scope.eReferralICD9Second ? 'Druga procedura ICD-9: ' + $scope.eReferralICD9Second.value + ' - ' + $scope.eReferralICD9Second.description + '.' : '';

            } else {
                $scope.referral.description = null;
            }
        }

        function beforeSave() {
            prepareIds();
        }

        function chooseSaveAction() {

        }

        function clearLaboratoryTestInputs() {
            $scope.selectedLaboratoryTestCategory = null;
            $scope.newLaboratoryTest.value = null;
            $scope.newLaboratoryTestCategory.value = null;
        }

        function addNewOffer(newOffer) {
            if(!$scope.referral.alabOffers) {
                $scope.referral.alabOffers = [];
            }

            $scope.preDefinedOfferList.forEach(function(offer) {
                if(offer.externalSystemIdentifier == newOffer.externalSystemIdentifier) {
                    offer.selected = true;
                }
            });

            var offer = new ALABOfferVO(newOffer.id, newOffer.name, newOffer.externalSystemIdentifier);
            $scope.referral.alabOffers.push(offer);
            $scope.newOffer = undefined;
            $scope.searchOfferText = '';
            if($scope.noOffersAdded) {
                $scope.noOffersAdded = !$scope.noOffersAdded;
            }
        }

        function setData() {
            $scope.Enum = Enum;

            $scope.presentDate = new Date();
            $scope.doctor = null;
            $scope.visit = visitCard;
            $scope.patient = patient;
            $scope.nfzContracts = nfzContracts;
            $scope.patientAge = $scope.presentDate.getFullYear() - $scope.patient.birthDate.getFullYear();
            $scope.payerTypeList = [];
            $scope.icd10List = [];
            $scope.newLaboratoryTestCategory = new DictionaryElementVO();
            $scope.newLaboratoryTest = new DictionaryElementVO();
            $scope.selectedLaboratoryTestCategory = null;

            $scope.noParentLabTestCategoryNameInserted = false;
            $scope.noLabTestCategoryNameInserted = false;
            $scope.noLabTestNameInserted = false;
            $scope.alabPaymentTypeChoiceRequired = false;

            $scope.nfzOfficeList = [];
            nfzOfficeModel.getDataPage({})

            if($injector.has('meedy.userModel')) {
                var alabPaymentType = $injector.get('meedy.userModel').currentMedicalPost.alabPaymentType;
                $scope.alabPaymentTypeChoiceRequired = alabPaymentType == Enum.MEEDY.ALAB_PAYMENT_TYPE.BOTH;
            }

            if(referral) {
                $scope.referral = angular.copy(referral);

                if($scope.referral.type != Enum.REFERRAL_TYPE.LABORATORY && $scope.referral.type != Enum.REFERRAL_TYPE.ALAB) {
                    diagnosis.forEach(function(element) {
                        if(element.icd10.id === $scope.referral.diagnosis[0].id) {
                            $scope.selectedDiagnosis = element.icd10;
                        }

                        $scope.icd10List.push(element.icd10);
                    });
                }
            } else {
                if (referralType === Enum.REFERRAL_TYPE.E_REFERRAL) {
                    $scope.referral = new EReferralVO();
                } else {
                    $scope.referral = new ReferralVO();
                }
                $scope.referral.dateOfIssue = new Date();
                $scope.referral.type = referralType;
                $scope.referral.clinic = $scope.visit.clinic;
                $scope.referral.patient = $scope.patient;
                $scope.referral.visitCard = new VisitCardVO($scope.visit.visitCard.id);
                $scope.referral.payer = null;
                $scope.newOffer = undefined;

                diagnosis.forEach(function(element) {
                    if(element.mainAffliction) {
                        $scope.selectedDiagnosis = element.icd10;
                    }
                    $scope.icd10List.push(element.icd10);
                });
            }

            $scope.laboratoryTestCategories = [];
            $scope.examinationTypes = Object.keys(Enum.EXAMINATION_TYPE);

            $scope.forms = {
                referral: null
            };

            $scope.previewOnly = previewOnly;
            $scope.laboratoryTestNameEditMode = false;
            $scope.laboratoryTestToEdit = null;
            $scope.laboratoryTestCategoryAction = false;
            $scope.laboratoryTestCategoryDeleteMode = false;
            $scope.laboratoryTestCategoryToDelete = null;

            $scope.addLaboratoryTestActions = {};
            $scope.init = true;
            $scope.activeStep = 'offers';
            $scope.noOffersAdded = false;
            $scope.uploadingEReferral = false;
            $scope.eReferralICD9 = null;
            $scope.eReferralICD9Second = null;
            $scope.eReferralDescription = null;

            $scope.preDefinedOfferGroups = {
                columnOne: [
                    {groupName: "Biochemia", offers: []}
                ],
                columnTwo: [
                    {groupName: "Hematologia", offers: []},
                    {groupName: "Hormony", offers: []},
                    {groupName: "Immunologia", offers: []},
                    {groupName: "Diagnostyka laboratoryjna infekcji", offers: []},
                    {groupName: "Badanie kału", offers: []},
                    {groupName: "Koaguologia", offers: []},
                    {groupName: "Badanie moczu", offers: []},
                    {groupName: "Markery", offers: []}
                ]
            };

            $scope.isEReferralSent = false;
            $scope.eReferralResponse = new EReferralResponseVO();

            $scope.preDefinedOfferList = [
                {
                    externalSystemIdentifier: 160,
                    icd9: "I09",
                    id: 1,
                    name: "Albumina - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 162,
                    icd9: "I17",
                    id: 2,
                    name: "Aminotransferaza alaninowa - ALT (GPT)",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 163,
                    icd9: "I19",
                    id: 3,
                    name: "Aminotransferaza asparaginianowa - AST (GOT)",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 166,
                    icd9: "I25",
                    id: 4,
                    name: "Amylaza - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 174,
                    icd9: "I77",
                    id: 5,
                    name: "Białko całkowite - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 177,
                    icd9: "I81",
                    id: 6,
                    name: "Białko ostrej fazy - CRP - ilościowo",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 179,
                    icd9: "I81",
                    id: 7,
                    name: "Białko C-reaktywne o wysokiej czułości (hsCRP)",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 180,
                    icd9: "I89",
                    id: 8,
                    name: "Bilirubina całkowita - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 182,
                    icd9: "O93",
                    id: 9,
                    name: "Całkowita zdolność surowicy do wiązania żelaza - TIBC",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 189,
                    icd9: "I99",
                    id: 9,
                    name: "Cholesterol całkowity",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 190,
                    icd9: "K01",
                    id: 10,
                    name: "Cholesterol HDL",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 191,
                    icd9: "K03",
                    id: 11,
                    name: "Cholesterol LDL metodą bezpośrednią",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 202,
                    icd9: "L11",
                    id: 12,
                    name: "Fosfataza alkaliczna - ALP",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 205,
                    icd9: "L15",
                    id: 13,
                    name: "Fosfataza kwaśna – całkowita - AcP",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 215,
                    icd9: "L31",
                    id: 14,
                    name: "Gammaglutamylotranspeptydaza - GGTP",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 225,
                    icd9: "L43",
                    id: 15,
                    name: "Glukoza na czczo we krwi żylnej",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 229,
                    icd9: "L55",
                    id: 16,
                    name: "Hemoglobina glikowana",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 237,
                    icd9: "M18",
                    id: 17,
                    name: "Kinaza kreatynowa - CK",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 243,
                    icd9: "M37",
                    id: 18,
                    name: "Kreatynina – mocz",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 244,
                    icd9: "M37",
                    id: 19,
                    name: "Kreatynina – mocz dobowy",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 245,
                    icd9: "M37",
                    id: 20,
                    name: "Kreatynina – surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 251,
                    icd9: "M45",
                    id: 21,
                    name: "Kwas moczowy - mocz",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 252,
                    icd9: "M45",
                    id: 22,
                    name: "Kwas moczowy - mocz dobowy",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 253,
                    icd9: "M45",
                    id: 23,
                    name: "Kwas moczowy - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 268,
                    icd9: "N13",
                    id: 24,
                    name: "Mocznik - mocz dobowy",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 269,
                    icd9: "N13",
                    id: 25,
                    name: "Mocznik - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 270,
                    icd9: "N13",
                    id: 26,
                    name: "Mocznik (mocz)",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 278,
                    icd9: "N45",
                    id: 27,
                    name: "Potas – mocz",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 279,
                    icd9: "N45",
                    id: 28,
                    name: "Potas – mocz dobowy",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 280,
                    icd9: "N45",
                    id: 29,
                    name: "Potas – surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 287,
                    icd9: "O35",
                    id: 30,
                    name: "Sód – mocz dobowy",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 288,
                    icd9: "O35",
                    id: 31,
                    name: "Sód – surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 291,
                    icd9: "O43",
                    id: 32,
                    name: "Transferyna",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 294,
                    icd9: "O49",
                    id: 33,
                    name: "Trójglicerydy TG",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 298,
                    icd9: "O77",
                    id: 34,
                    name: "Wapń - mocz dobowy",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 299,
                    icd9: "O77",
                    id: 35,
                    name: "Wapń całkowity - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 307,
                    icd9: "O95",
                    id: 36,
                    name: "Żelazo na czczo - surowica",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 2292,
                    icd9: "I87",
                    id: 37,
                    name: "Bilirubina związana (bezpośrednia)",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 5387,
                    icd9: "K03",
                    id: 38,
                    name: "Cholesterol LDL wyliczany",
                    group: "Biochemia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 138,
                    icd9: "C55",
                    id: 39,
                    name: "Eozynofilia bezwzględna - krew",
                    group: "Hematologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 145,
                    icd9: "C55",
                    id: 40,
                    name: "Morfologia pełna – analizator – krew",
                    group: "Hematologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 149,
                    icd9: "C59",
                    id: 41,
                    name: "OB – odczyn Biernackiego",
                    group: "Hematologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 152,
                    icd9: "C69",
                    id: 42,
                    name: "Retikulocyty - krew",
                    group: "Hematologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 382,
                    icd9: "L69",
                    id: 43,
                    name: "Hormon tyreotropowy - TSH",
                    group: "Hormony",
                    selected: false
                },
                {
                    externalSystemIdentifier: 430,
                    icd9: "O55",
                    id: 44,
                    name: "Trójjodotyronina wolna - fT3",
                    group: "Hormony",
                    selected: false
                },
                {
                    externalSystemIdentifier: 435,
                    icd9: "O69",
                    id: 45,
                    name: "Tyroksyna wolna - fT4",
                    group: "Hormony",
                    selected: false
                },
                {
                    externalSystemIdentifier: 544,
                    icd9: "K21",
                    id: 46,
                    name: "Czynnik reumatoidalny - ilościowo",
                    group: "Immunologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 5392,
                    icd9: "K21",
                    id: 47,
                    name: "Czynnik reumatoidalny RF IgM",
                    group: "Immunologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 5393,
                    icd9: "K21",
                    id: 48,
                    name: "Czynnik reumatoidalny RF IgG",
                    group: "Immunologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 446,
                    icd9: "K21",
                    id: 49,
                    name: "HBs-antygen",
                    group: "Diagnostyka laboratoryjna infekcji",
                    selected: false
                },
                {
                    externalSystemIdentifier: 128,
                    icd9: "A17",
                    id: 50,
                    name: "Kał - krew utajona",
                    group: "Badanie kału",
                    selected: false
                },
                {
                    externalSystemIdentifier: 133,
                    icd9: "A21",
                    id: 51,
                    name: "Kał - Pasożyty",
                    group: "Badanie kału",
                    selected: false
                },
                {
                    externalSystemIdentifier: 135,
                    icd9: "A23",
                    id: 53,
                    name: "Kał na stopień strawienia",
                    group: "Badanie kału",
                    selected: false
                },
                {
                    externalSystemIdentifier: 326,
                    icd9: "G11",
                    id: 54,
                    name: "APTT (czas kaolinowo-kefalinowy)",
                    group: "Koaguologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 345,
                    icd9: "G53",
                    id: 55,
                    name: "Fibrynogen",
                    group: "Koaguologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 5150,
                    icd9: "G21",
                    id: 56,
                    name: "PT (INR)",
                    group: "Koaguologia",
                    selected: false
                },
                {
                    externalSystemIdentifier: 1522,
                    icd9: "A01",
                    id: 57,
                    name: "Mocz – badanie ogólne",
                    group: "Badanie moczu",
                    selected: false
                },
                {
                    externalSystemIdentifier: 109,
                    icd9: "A07",
                    id: 58,
                    name: "Mocz - białko",
                    group: "Badanie moczu",
                    selected: false
                },
                {
                    externalSystemIdentifier: 120,
                    icd9: "O35",
                    id: 59,
                    name: "Mocz - sód",
                    group: "Badanie moczu",
                    selected: false
                },
                {
                    externalSystemIdentifier: 1527,
                    icd9: "O77",
                    id: 60,
                    name: "Mocz - wapń",
                    group: "Badanie moczu",
                    selected: false
                },
                {
                    externalSystemIdentifier: 122,
                    icd9: "A07",
                    id: 61,
                    name: "Mocz dobowy - białko",
                    group: "Badanie moczu",
                    selected: false
                },
                {
                    externalSystemIdentifier: 3807,
                    icd9: "A15",
                    id: 62,
                    name: "Glukoza w DZM",
                    group: "Badanie moczu",
                    selected: false
                },
                {
                    externalSystemIdentifier: 744,
                    icd9: "I61",
                    id: 63,
                    name: "Antygen swoisty dla prostaty - PSA całkowity",
                    group: "Markery",
                    selected: false
                }
            ];

            var fillGroupedPredefinedOffers = function() {
                var groupedOffers = {};
                $scope.preDefinedOfferList.forEach(function(offer){
                    if(!groupedOffers[offer.group]) groupedOffers[offer.group] = [];
                    groupedOffers[offer.group].push(offer);
                });
                for (var idx in $scope.preDefinedOfferGroups.columnOne) {
                    $scope.preDefinedOfferGroups.columnOne[idx].offers = groupedOffers[$scope.preDefinedOfferGroups.columnOne[idx].groupName];
                }
                for (var idx in $scope.preDefinedOfferGroups.columnTwo) {
                    $scope.preDefinedOfferGroups.columnTwo[idx].offers = groupedOffers[$scope.preDefinedOfferGroups.columnTwo[idx].groupName];
                }
            };

            fillGroupedPredefinedOffers();
            $scope.showPreDefinedOffers = true;
        }

        function setPermissions() {
            //
        }

        function setListeners() {
            $scope.$watch('selectedDiagnosis', function(newVal, oldVal) {
                if(newVal) {
                    $scope.referral.diagnosis = [newVal];
                } else {
                    $scope.referral.diagnosis = [];
                }
            });

            $scope.$on(Event.NFZ_OFFICE.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.nfzOfficeList = dataPage.data;
            });

            $scope.$watch('selectedLaboratoryTestCategory.value', function(newVal) {
                if(newVal && $scope.noParentLabTestCategoryNameInserted) {
                    $scope.noParentLabTestCategoryNameInserted = false;
                }
            });

            $scope.$watch('newLaboratoryTest.value', function(newVal) {
                if(newVal && $scope.noLabTestNameInserted) {
                    $scope.noLabTestNameInserted = false;
                }
            });

            $scope.$watch('newLaboratoryTestCategory.value', function(newVal) {
                if(newVal && !$scope.laboratoryTestNameChanged) {
                    $scope.laboratoryTestNameChanged = true;
                }
            });

            $scope.$on(Event.DOCTOR.GET_BY_ID.SUCCESS, function (event, data) {
                $scope.doctor = data;
            });

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function(event, data, code) {
                if(code === Constant.DICTIONARY_CODE.LABORATORY_TEST) {
                    $scope.allLaboratoryTestCategories = data.data.filter(function(element) {
                        return !element.parent;
                    });

                    $scope.laboratoryTestCategories = data.data.filter(function(element) {
                        return !element.parent && !element.deleted; //fixme change filtering
                    });

                    $scope.laboratoryTestCategories.forEach(function(el, idx) {
                        $scope.addLaboratoryTestActions[idx] = $scope.addLaboratoryTestActions[idx] || {};
                        $scope.addLaboratoryTestActions[idx].showInput = false;
                        $scope.addLaboratoryTestActions[idx].error = false;
                        $scope.addLaboratoryTestActions[idx].value = '';

                        if($scope.init) {
                            $scope.addLaboratoryTestActions[idx].showLabTests = false;
                        }
                    });

                }
            });

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function(event, data, code) {
                if(code === Constant.DICTIONARY_CODE.PAYER) {
                    $scope.payerTypeList = data.data;

                    if($scope.referral.payer) {
                        $scope.payerTypeList.forEach(function(element) {
                            if($scope.referral.payer.id === element.id) {
                                $scope.referral.payer = element;
                            }
                        });
                    } else {
                        $scope.referral.payer = $scope.payerTypeList[0];
                    }
                }
            });

            $scope.$on(Event.DICTIONARY.SAVE_DICTIONARY_ELEMENT.SUCCESS, function() {
                if($scope.referral.type === Enum.REFERRAL_TYPE.LABORATORY) {
                    var criteria = {
                        authorId: userModel.getCurrentContextDoctorId()
                    };
                    dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.LABORATORY_TEST, criteria);
                    clearLaboratoryTestInputs();
                }
            });

            $scope.$on(Event.DICTIONARY.DELETE_DICTIONARY_ELEMENT.SUCCESS, function() {
                $scope.laboratoryTestCategoryAction = false;
                $scope.laboratoryTestCategoryDeleteMode = false;
                $scope.laboratoryTestCategoryToDelete = null;
                if($scope.referral.type === Enum.REFERRAL_TYPE.LABORATORY) {
                    var criteria = {
                        authorId: userModel.getCurrentContextDoctorId()
                    };
                    dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.LABORATORY_TEST, criteria);
                }
            });

            $scope.$on(Event.DICTIONARY.UPDATE_DICTIONARY_ELEMENT.SUCCESS, function() {
                if($scope.referral.type === Enum.REFERRAL_TYPE.LABORATORY) {
                    var criteria = {
                        authorId: userModel.getCurrentContextDoctorId()
                    };
                    dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.LABORATORY_TEST, criteria);
                    clearLaboratoryTestInputs();

                }
                if($scope.laboratoryTestNameEditMode) {
                    $scope.laboratoryTestToEdit = null;
                    $scope.laboratoryTestNameEditMode = false;
                }
            });

            $scope.$watch('newOffer', function(newVal) {
                if(newVal) {
                    addNewOffer(newVal);
                }
            });

            $scope.$on(Event.LOADING, function (event, isLoading) {
                if (isLoading && $scope.uploadingEReferral) {
                    var configPopup = {
                        template: '<img style="height: 50px; object-fit: contain;" src="./core/resource/asset/loader_blue.gif">' +
                                    '<h4 style="text-align: center;">Trwa przesyłanie dokumentu</h4>',
                        skipHide: true
                    };

                    $scope.spinner = $mdDialog.show(configPopup);
                } else {
                    if ($scope.spinner) {
                        $mdDialog.hide($scope.spinner);
                    }
                }
            });

        }

        function setActions() {
            $scope.save = function(print) {
                beforeSave();

                $scope.forms.referral.$setSubmitted();
                if($scope.forms.referral.$valid) {
                    var returnObject = {
                        referral: null,
                        print: false
                    };

                    if($scope.referral.id) {
                        referralModel.update($scope.referral).then(function(ref) {
                            returnObject.referral = ref;
                            checkForDownload(returnObject);
                        });

                    } else {
                        referralModel.save($scope.referral).then(function(ref) {
                            returnObject.referral = ref;
                            checkForDownload(returnObject);
                        });
                    }
                }

                function checkForDownload(obj) {
                    if(print) {
                        $scope.previewOnly = true;
                        referralModel.downloadPDF(obj.referral.id).then(function(link) {
                            window.open(link, '_blank');
                            window.focus();
                            $mdDialog.hide(obj);
                        });
                    } else {
                        $mdDialog.hide(obj);
                    }
                }
            };

            $scope.sendEReferral = function() {

                $scope.forms.referral.$setSubmitted();

                if($scope.forms.referral.$valid) {
                    beforeSave();

                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-sign-prescription.html',
                        controller: 'popupSignPrescriptionController',
                        controllerAs: 'signPrescriptionCtrl',
                        skipHide: true,
                        locals: {
                            $scope: $scope,
                            $mdDialog: $mdDialog,
                            title: 'Podpisz receptę certyfikatem ZUS',
                            message: 'Podaj hasło do certyfikatu',
                            altButtons: false
                        }
                    };

                    $mdDialog.show(configPopup).then(function(password) {
                        if(password) {
                            $scope.referral.certificatePassword = password;
                            $scope.uploadingEReferral = true;
                            referralModel.sendEReferral($scope.referral).then(function(data) {
                                $scope.eReferralResponse = data;
                                $scope.isEReferralSent = true;
                                $scope.uploadingEReferral = false;

                                $('md-dialog-content').animate({
                                    scrollTop: '+=2000px'
                                });
                            });
                        }
                    });
                }
            };

            $scope.print = function() {
                referralModel.downloadPDF($scope.referral.id).then(function(link) {
                    window.open(link, '_blank');
                    window.focus();
                    $mdDialog.hide(obj);
                });
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.goToSettings = function() {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);
            }

            $scope.setNfzBranch = function(event) {
                if(event.nfzBranch) {
                    $scope.referral.nfzBranch = event.nfzBranch;
                }
            }

            $scope.openLaboratoryTab = function(evt, idx) {
                if($scope.laboratoryTestCategoryAction) {
                    return false;
                }

                $scope.addLaboratoryTestActions[idx].showLabTests = !$scope.addLaboratoryTestActions[idx].showLabTests;

                if(!$scope.addLaboratoryTestActions[idx].showLabTests) {
                    $scope.addLaboratoryTestActions[idx] = {
                        showInput: false,
                        error: false,
                        value: ''
                    };
                }
            };

            $scope.checkedEntities = function(parentElement) {
                var mapped = parentElement.children.map(function(el) {
                    return el.checked;
                });
                return mapped.indexOf(true) != -1;
            };

            $scope.addNewLaboratoryTestCategory = function() {
                if(!$scope.newLaboratoryTestCategory.value) {
                    $scope.noLabTestCategoryNameInserted = true;
                    return false;
                }
                dictionaryModel.saveDictionaryElement(Constant.DICTIONARY_CODE.LABORATORY_TEST, $scope.newLaboratoryTestCategory);
            };

            $scope.addNewLaboratoryTest = function(index) {
                if(!$scope.addLaboratoryTestActions[index].showInput && !$scope.addLaboratoryTestActions[index].error) {
                    $scope.addLaboratoryTestActions[index].showInput = true;
                    return;
                }

                if(!$scope.addLaboratoryTestActions[index].value.length && $scope.addLaboratoryTestActions[index].showInput) {
                    $scope.addLaboratoryTestActions[index].error = true;
                    return;
                } else {
                    if($scope.addLaboratoryTestActions[index].error) {
                        $scope.addLaboratoryTestActions[index].error = false;
                    }
                }

                var laboratoryTest = new DictionaryElementVO();
                laboratoryTest.parent = $scope.laboratoryTestCategories[index];
                laboratoryTest.value = $scope.addLaboratoryTestActions[index].value;

                $scope.newLaboratoryTest.parent = $scope.selectedLaboratoryTestCategory;
                dictionaryModel.saveDictionaryElement(Constant.DICTIONARY_CODE.LABORATORY_TEST, laboratoryTest);
                $scope.addLaboratoryTestActions[index].showInput = false;

            };

            $scope.changeLaboratoryTestName = function(laboratoryTest) {
                $scope.laboratoryTestToEdit = laboratoryTest;
                $scope.laboratoryTestNameEditMode = true;
            };

            $scope.saveChangedLaboratoryTestName = function (labTest) {
                dictionaryModel.updateDictionaryElement(Constant.DICTIONARY_CODE.LABORATORY_TEST, labTest);
            };

            $scope.deleteLaboratoryTest = function(laboratoryTest) {
                $scope.laboratoryTestNameEditMode = false;
                dictionaryModel.deleteDictionaryElement(Constant.DICTIONARY_CODE.LABORATORY_TEST, laboratoryTest);
            };

            $scope.editLaboratoryTestCategory = function(laboratoryTest) {
                $scope.laboratoryTestToEdit = laboratoryTest;
                $scope.laboratoryTestCategoryAction = true;
                $scope.laboratoryTestNameEditMode = true;

                if($scope.laboratoryTestCategoryAction || $scope.laboratoryTestCategoryDeleteMode) {
                    $scope.laboratoryTestCategoryAction = false;
                    $scope.laboratoryTestCategoryDeleteMode = false;
                }
            };

            $scope.deleteLaboratoryTestCategory = function(laboratoryTestCategory) {
                $scope.laboratoryTestCategoryAction = true;
                $scope.laboratoryTestCategoryDeleteMode = true;
                $scope.laboratoryTestCategoryToDelete = laboratoryTestCategory;

                if($scope.laboratoryTestCategoryAction || $scope.laboratoryTestNameEditMode) {
                    $scope.laboratoryTestToEdit = null;
                    $scope.laboratoryTestCategoryAction = false;
                    $scope.laboratoryTestNameEditMode = false;
                }
            };

            $scope.confirmDeleteLaboratoryTestCategory = function() {
                dictionaryModel.deleteDictionaryElement(Constant.DICTIONARY_CODE.LABORATORY_TEST, $scope.laboratoryTestCategoryToDelete); //fixme dodać alert z zapewnieniem
            };

            $scope.cancelDeleteLaboratoryTestCategory = function(laboratoryTestCategory) {
                $scope.laboratoryTestCategoryAction = false;
                $scope.laboratoryTestCategoryDeleteMode = false;
            };


            $scope.removeOffer = function(idx) {
                $scope.preDefinedOfferList.forEach(function(offer) {
                    if(offer.externalSystemIdentifier == $scope.referral.alabOffers[idx].externalSystemIdentifier) {
                        offer.selected = false;
                    }
                });

                $scope.referral.alabOffers.splice(idx, 1);
            };

            $scope.nextStep = function() {
                if($scope.activeStep === 'offers') {
                    if(!$scope.referral.alabOffers.length) {
                        $scope.noOffersAdded = true;
                        return false;
                    }
                    var meedyOffers = new MeedyOffersWrapper();
                    meedyOffers.data = $scope.referral.alabOffers;


                    if(!$scope.previewOnly) {
                        meedyALABModel.getResources(meedyOffers).then(function(dataPage) {
                            $scope.resources = (dataPage.resources.length) ? dataPage.resources : [];
                            $scope.activeStep = 'resources';

                            $scope.resources.forEach(function(resource) {
                                resource.externalSystemIdentifier = resource.id;
                            });

                            var list = [];

                            list = $scope.resources.filter(function(resource) {
                                return resource.address.city === $scope.patient.registeredAddress.city;
                            });

                            $scope.resources = $scope.resources.filter(function(resource) {
                                return resource.address.city != $scope.patient.registeredAddress.city;
                            });

                            $scope.resources = list.concat($scope.resources);
                        });
                    } else {
                        $scope.activeStep = 'resources';
                        return;
                    }
                }
                if($scope.activeStep === 'resources') {
                    if($scope.referral.alabResource) {
                        $scope.activeStep = 'delegate';
                    }
                }
            };

            $scope.previousStep = function() {
                if($scope.activeStep === 'resources') {
                    $scope.activeStep = 'offers';
                }
                if($scope.activeStep === 'delegate') {
                    $scope.activeStep = 'resources';
                }
            };

            $scope.querySearchOffers = function(query) {
                var criteria = { rowsPerSheet: Constant.NUMBER.INT_MAX_VALUE, searchPhrase: query };
                var deferred = $q.defer();
                meedyALABModel.getDataPage(criteria).then(function(dataPage) {
                    if (dataPage.data) {
                        $scope.items = dataPage.data;
                    } else {
                        $scope.items = [];
                    }
                    deferred.resolve($scope.items);
                });
                return deferred.promise;
            };

            $scope.querySearch = function(query) {
                return query ? $scope.resources.filter($scope.searchForResource(query)) : $scope.resources;
            };

            $scope.searchForResource = function(q) {
                return function filterFunc(resource) {
                    return (resource.name.indexOf(q) != -1);
                };
            };


            $scope.actionForPreDefinedOffer = function(offer) {
                if(offer.selected) {
                    addNewOffer(offer);
                } else {
                    var idx = _.findIndex($scope.referral.alabOffers, {externalSystemIdentifier: offer.externalSystemIdentifier});
                    $scope.removeOffer(idx);
                    offer.selected = false;
                }
            };

            $scope.resetNfzInputValues = function() {
                if ($scope.referral.nfz) {
                    $scope.referral.nfzContractNummber = null;
                }
            };
        }

        function configureInterface() {
            //
        }

        function initialize() {
            doctorModel.getById(userModel.getCurrentContextDoctorId());
            if($scope.referral.type === Enum.REFERRAL_TYPE.LABORATORY) {
                var criteria = {
                    authorId: userModel.getCurrentContextDoctorId()
                };
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.LABORATORY_TEST, criteria);
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.PAYER, criteria);
            }

            if ($scope.nfzContracts.length === 1) {
                $scope.setNfzBranch($scope.nfzContracts[0]);
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
